export default __webpack_public_path__ + "static/media/iconmonstr-x-mark-1.54409d3a.svg";